import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { GroupsComponent } from "./index";
import { GroupsService } from "./services/groups.service";
import { FormsModule } from "@angular/forms";
import { AppSharedModule } from "../../shared/app-shared.module";
import { RouterModule } from "@angular/router";

import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { EventsComponent } from "./index";
import { StudentModule } from "../student/student.module";
import { AlertMaintComponent } from "./AlertMaint/alertmaint.component";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DialogModule } from "primeng/dialog";
import { ConfirmationService } from "primeng/api";
import { CalendarModule } from "primeng/calendar";
// import { FullCalendarModule } from "primeng/fullcalendar";
import { TableModule } from "primeng/table";
import { DropdownModule } from "primeng/dropdown";
import { InputNumberModule } from "primeng/inputnumber";
import { CheckboxModule } from "primeng/checkbox";
import { RadioButtonModule } from "primeng/radiobutton";
import { InputMaskModule } from "primeng/inputmask";

import { EventsAssignStudentsComponent } from "./events-assign-students/events-assign-students.component";
import { EventsEventScanningResultsComponent } from "./events-event-scanning-results/events-event-scanning-results.component";
import { ViewDetailsComponent } from "./events-event-scanning-results/view-details/view-details.component";
import { AddDynamicGroupComponent } from "./events-assign-students/add-dynamic-group/add-dynamic-group.component";
import { EditDynamicGroupComponent } from "./events-assign-students/edit-dynamic-group/edit-dynamic-group.component";
import { EditStudentGroupsComponent } from "./edit-student-groups/edit-student-groups.component";
import { AddStudentGroupComponent } from "./edit-student-groups/add-student-group/add-student-group.component";

import { StudentGroupEditComponent } from "./edit-student-groups/student-group-edit/student-group-edit.component";
import { UnassignedTableComponent } from "./edit-student-groups/student-group-edit/unassigned-table/unassigned-table.component";
import { AssignedTableComponent } from "./edit-student-groups/student-group-edit/assigned-table/assigned-table.component";
import { GroupActionTableComponent } from "./edit-student-groups/student-group-edit/group-action-table/group-action-table.component";
import { GroupActionPickerComponent } from "./edit-student-groups/student-group-edit/group-action-table/group-action-picker/group-action-picker.component";
import { SGAddIncidentComponent } from "./edit-student-groups/student-group-edit/group-action-table/sgadd-incident/sgadd-incident.component";
import { SGAddReleaseComponent } from "./edit-student-groups/student-group-edit/group-action-table/sgadd-release/sgadd-release.component";
import { SGAddFineComponent } from "./edit-student-groups/student-group-edit/group-action-table/sgadd-fine/sgadd-fine.component";
import { SGEditIncidentComponent } from "./edit-student-groups/student-group-edit/group-action-table/sgedit-incident/sgedit-incident.component";
import { SGEditReleaseComponent } from "./edit-student-groups/student-group-edit/group-action-table/sgedit-release/sgedit-release.component";
import { StudentGroupsTableRefreshService } from "./edit-student-groups/student-group-edit/shared/student-groups-table-refresh.service";
import { SGAddFineWarningComponent } from "./edit-student-groups/student-group-edit/group-action-table/sgadd-fine-warning/sgadd-fine-warning.component";
import { SGBasicIncidentComponent } from "./edit-student-groups/student-group-edit/group-action-table/sgadd-incident/sgbasic-incident/sgbasic-incident.component";
import { SGAdvancedIncidentComponent } from "./edit-student-groups/student-group-edit/group-action-table/sgadd-incident/sgadvanced-incident/sgadvanced-incident.component";
import { GroupActionCommentComponent } from "./edit-student-groups/student-group-edit/shared/group-action-comment/group-action-comment.component";
import { GroupActionService } from "./edit-student-groups/student-group-edit/shared/group-action.service";
import { DeleteIncidentWarningComponent } from "./edit-student-groups/student-group-edit/group-action-table/delete-incident-warning/delete-incident-warning.component";
import { DeleteFineWarningComponent } from "./edit-student-groups/student-group-edit/group-action-table/delete-fine-warning/delete-fine-warning.component";
import { AssignGroupActionsComponent } from "./edit-student-groups/student-group-edit/unassigned-table/assign-group-actions/assign-group-actions.component";
import { AssignDefaultActionsComponent } from "./edit-student-groups/student-group-edit/unassigned-table/assign-group-actions/assign-default-actions/assign-default-actions.component";
import { AssignOptionalActionsComponent } from "./edit-student-groups/student-group-edit/unassigned-table/assign-group-actions/assign-optional-actions/assign-optional-actions.component";
import { UnassignGroupActionsComponent } from "./edit-student-groups/student-group-edit/assigned-table/unassign-group-actions/unassign-group-actions.component";
import { UpdateOldPromptComponent } from "./edit-student-groups/student-group-edit/group-action-table/sgedit-release/update-old-prompt/update-old-prompt.component";
import { ActionsToRemoveComponent } from "./edit-student-groups/student-group-edit/assigned-table/unassign-group-actions/actions-to-remove/actions-to-remove.component";
import { SGEditBasicComponent } from "./edit-student-groups/student-group-edit/group-action-table/sgedit-incident/sgedit-basic/sgedit-basic.component";
import { SGEditAdvancedComponent } from "./edit-student-groups/student-group-edit/group-action-table/sgedit-incident/sgedit-advanced/sgedit-advanced.component";
import { EventsScheduledEventsComponent } from "./events-scheduled-events/events-scheduled-events.component";
import { ScheduleEditEventComponent } from "./events-scheduled-events/schedule-edit-event/schedule-edit-event.component";
import { DefineEventsComponent } from "./define-events/define-events.component";
import { GroupsAddEventComponent } from "./define-events/groups-add-event/groups-add-event.component";
import { GroupsEditEventComponent } from "./define-events/groups-edit-event/groups-edit-event.component";
import { DataService_DefineEvents } from "./define-events/shared/data.service";
import { ScheduledEventDialogComponent } from "./events-scheduled-events/scheduled-event-dialog/scheduled-event-dialog.component";
import { SchoolselectorModule } from "../schoolselector/schoolselector.module";
import { ImportGroupDataComponent } from "./edit-student-groups/import-group-data/import-group-data.component";
import { GroupImportColumnTableComponent } from "./edit-student-groups/import-group-data/group-import-column-table/group-import-column-table.component";
import { GroupImportStudentDataTableComponent } from "./edit-student-groups/import-group-data/group-import-student-data-table/group-import-student-data-table.component";
import { AddToGroupComponent } from "./add-to-group/add-to-group.component";
import { AccordionModule } from "primeng/accordion";
import { GroupStudentsToAddComponent } from "./add-to-group/group-students-to-add/group-students-to-add.component";
import { PersonSelectorModule } from "../personselector/personselector.module";
import { DataService_AddToGroup } from "./add-to-group/shared/data.sevice";
import { DeleteGroupOptionsComponent } from "./edit-student-groups/delete-group-options/delete-group-options.component";
import { SGAddPBISComponent } from "./edit-student-groups/student-group-edit/group-action-table/sgadd-pbis/sgadd-pbis.component";
import { ScheduledEventsCalendarComponent } from "./events-scheduled-events/scheduled-events-calendar/scheduled-events-calendar.component";
import { SGAddReminderComponent } from "./edit-student-groups/student-group-edit/group-action-table/sgadd-reminder/sgadd-reminder.component";
import { DeleteReminderWarningComponent } from "./edit-student-groups/student-group-edit/group-action-table/delete-reminder-warning/delete-reminder-warning.component";
import { SGEditReminderComponent } from "./edit-student-groups/student-group-edit/group-action-table/sgedit-reminder/sgedit-reminder.component";
import { ColorPickerModule } from "primeng/colorpicker";
import { SGAddPortalNotificationComponent } from './edit-student-groups/student-group-edit/group-action-table/sgadd-portal-notification/sgadd-portal-notification.component';

@NgModule({
	declarations: [
		GroupsComponent,
		EventsComponent,
		AlertMaintComponent,
		DefineEventsComponent,
		ViewDetailsComponent,
		AddDynamicGroupComponent,
		EditDynamicGroupComponent,
		EventsAssignStudentsComponent,
		EventsEventScanningResultsComponent,
		ScheduleEditEventComponent,
		EditStudentGroupsComponent,
		AddStudentGroupComponent,
		StudentGroupEditComponent,
		UnassignedTableComponent,
		AssignedTableComponent,
		GroupActionTableComponent,
		GroupActionPickerComponent,
		SGAddIncidentComponent,
		SGAddReleaseComponent,
		SGAddFineComponent,
		SGEditIncidentComponent,
		SGEditReleaseComponent,
		SGAddFineWarningComponent,
		SGBasicIncidentComponent,
		SGAdvancedIncidentComponent,
		GroupActionCommentComponent,
		DeleteIncidentWarningComponent,
		DeleteFineWarningComponent,
		AssignGroupActionsComponent,
		AssignDefaultActionsComponent,
		AssignOptionalActionsComponent,
		UnassignGroupActionsComponent,
		UpdateOldPromptComponent,
		ActionsToRemoveComponent,
		SGEditBasicComponent,
		SGEditAdvancedComponent,
		EventsScheduledEventsComponent,
		GroupsAddEventComponent,
		GroupsEditEventComponent,
		ScheduledEventDialogComponent,
		ImportGroupDataComponent,
		GroupImportColumnTableComponent,
		GroupImportStudentDataTableComponent,
		AddToGroupComponent,
		GroupStudentsToAddComponent,
		DeleteGroupOptionsComponent,
		SGAddPBISComponent,
		ScheduledEventsCalendarComponent,
		SGAddReminderComponent,
		DeleteReminderWarningComponent,
		SGEditReminderComponent,
  SGAddPortalNotificationComponent,
	],

	imports: [
		StudentModule,
		CommonModule,
		FormsModule,
		AppSharedModule,
		RouterModule,
		BrowserAnimationsModule,
		ConfirmDialogModule,
		DialogModule,
		CalendarModule,
		// FullCalendarModule,
		TableModule,
		DropdownModule,
		InputNumberModule,
		CheckboxModule,
		RadioButtonModule,
		InputMaskModule,
		SchoolselectorModule,
		AccordionModule,
		PersonSelectorModule,
		ColorPickerModule,
	],
	providers: [GroupsService, ConfirmationService, StudentGroupsTableRefreshService, GroupActionService, DataService_DefineEvents, DataService_AddToGroup],
})
export class GroupsModule {}
